import React from "react"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"

import { getCmsAssetsUrl } from "../../helpers/general"
import { getSiteConfig } from "../../hooks/use-site-config"

import styles from "./Footer.module.scss"

const assetsUrl = getCmsAssetsUrl()

const Footer = ({ areaB }) => {
  const { t } = useTranslation()
  const site = getSiteConfig()
  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        <div className={styles.footerTopLeft}>
          <img
            src={`${assetsUrl}/images/${site.code}/logos/ingeteamev-electrifying.svg`}
            alt="Ingeteam"
            className={styles.logo}
          />
          <a href="https://www.ingeteam.com" target="_blank" rel="noopener noreferrer" className={styles.visitLink}>
            <span>{t("visit", { defaultValue: "Visit ingeteam.com" })}</span>
            
            <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M0.0685281 8.01172C0.0687046 7.76173 0.2715 7.55923 0.521483 7.5594L20.2346 7.57332C20.4846 7.57349 20.6871 7.77629 20.6869 8.02627C20.6868 8.27626 20.484 8.47877 20.234 8.47859L0.520844 8.46467C0.270861 8.4645 0.0683517 8.2617 0.0685281 8.01172Z" fill="white"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M13.3377 0.643474C13.5187 0.47104 13.8052 0.477979 13.9776 0.658973L20.9686 7.99695L13.9784 15.3643C13.8064 15.5456 13.5199 15.5532 13.3385 15.3811C13.1572 15.209 13.1497 14.9225 13.3217 14.7412L19.7194 7.99823L13.3222 1.28341C13.1498 1.10242 13.1567 0.815908 13.3377 0.643474Z" fill="white"/>
            </svg>
          </a>
        </div>
        <div className={styles.footerTopRight}>
          <p>{t("sigamos en contacto", { defaultValue: "Let's stay in touch" })}</p>
          <div className={styles.socials}>
            {site.socialMedia && site.socialMedia.map(social => (
              <a
                key={social.code}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialIcon}
              >
                <img
                  src={`${assetsUrl}/images/${site.code}/logos/${social.code}.svg`}
                  alt={social.code}
                />
              </a>
            ))}
          </div>
          <a href="https://www.ingeteam.com" target="_blank" rel="noopener noreferrer" className={styles.visitLink}>
            <span>{t("visit", { defaultValue: "Visit ingeteam.com" })}</span>
            
            <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M0.0685281 8.01172C0.0687046 7.76173 0.2715 7.55923 0.521483 7.5594L20.2346 7.57332C20.4846 7.57349 20.6871 7.77629 20.6869 8.02627C20.6868 8.27626 20.484 8.47877 20.234 8.47859L0.520844 8.46467C0.270861 8.4645 0.0683517 8.2617 0.0685281 8.01172Z" fill="white"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M13.3377 0.643474C13.5187 0.47104 13.8052 0.477979 13.9776 0.658973L20.9686 7.99695L13.9784 15.3643C13.8064 15.5456 13.5199 15.5532 13.3385 15.3811C13.1572 15.209 13.1497 14.9225 13.3217 14.7412L19.7194 7.99823L13.3222 1.28341C13.1498 1.10242 13.1567 0.815908 13.3377 0.643474Z" fill="white"/>
            </svg>
          </a>
        </div>
      </div>
      <div className={styles.separator}></div>
      <div className={styles.footerBottom}>
        <p className={styles.copyright}>
          &copy; Ingeteam {t("All Rights Reserved")}
        </p>
        <div className={styles.areaRight}>{areaB}</div>
      </div>
    </footer>
  )
}
export default Footer
Footer.propTypes = {
  areaB: PropTypes.node,
}
Footer.defaultProps = {
  areaB: PropTypes.node,
}
